import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store/state';
import { MutationTypes } from './mutations';
import { type AuthState } from './state'; // Changed from 'import authState from './state';'

// eslint-disable-next-line no-shadow
export enum ActionTypes {}
// Nexus actions removed - will be handled directly in components
// Only keeping any existing realm-based actions if needed
type AuthActionCtx = ActionContext<AuthState, RootState>;

export type AuthActions = ActionTree<AuthState, RootState>;

export const actions: AuthActions = {
  // Nexus actions removed - components will call nexus client directly
};
